/**
 * Every user-facing string this surface owns.
 *
 * The «what was not affected» sentence is written for a PAID surface: it names
 * the account, the subscription and the list, which is exactly what the same
 * page on the public host cannot say, because a visitor there has no account
 * to be reassured about.
 *
 * No status number appears anywhere below, and none may be added.
 */
export const notFoundCopy = {
  documentTitle: 'الصفحة غير موجودة — شاهدني',
  heading: 'هذه الصفحة لم تعد موجودة',
  body: 'قد يكون العنوان الذي وصلت منه قديماً، أو أن ما تبحث عنه غادر الفهرس. لم يتغيّر شيء في حسابك ولا في اشتراكك ولا في قائمتك، وبقيّة الصفحات تعمل كالمعتاد.',

  actions: {
    /** The primary way out is the area's own entry. */
    home: 'عد إلى الرئيسية',
    /**
     * The second is the fastest recovery from a dead address, and the results
     * page is served on the public host — so this leaves, exactly as the
     * top bar's search form does.
     */
    search: 'ابحث في الفهرس',
  },
} as const;
